export enum StateStatus {
  NOT_YET_TIME = "NOT_YET_TIME",
  ON_GOING = "ON_GOING",
  ELAPSED = "ELAPSED"
}
